import React from 'react';

export interface RadioCheckInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label: string;
  type: 'radio' | 'check';
  inputClassName?: string;
  labelClassName?: string;
}

export const RadioCheckInput = React.forwardRef<
  HTMLInputElement,
  RadioCheckInputProps
>(function _RadioCheckInput(
  {
    label,
    className = '',
    labelClassName = '',
    inputClassName = '',
    type,
    ...props
  },
  ref
) {
  switch (type) {
    case 'radio':
      return (
        <label className={`inline-flex items-center ${className}`}>
          <input
            className={`form-radio ${inputClassName}`}
            type="radio"
            {...props}
            ref={ref}
          />
          <span className={`ml-2 text-gray-500 font-bold ${labelClassName}`}>
            {label}
          </span>
        </label>
      );
    case 'check':
      return (
        <label className={`inline-flex items-center ${className}`}>
          <input
            className={`form-checkbox ${inputClassName}`}
            type="checkbox"
            {...props}
            ref={ref}
          />
          <span className={`ml-2 text-gray-500 font-bold ${labelClassName}`}>
            {label}
          </span>
        </label>
      );
    default:
      return null;
  }
});
